// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_he-0";
export var optionCard = "_he-1";